module.exports = __webpack_public_path__ + "static/media/my-garage.c57e9d08.svg";